module.exports = __webpack_public_path__ + "static/img/plat_03.84f1794.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/internetPlat/plat_03.jpg
// module id = GdL2
// module chunks = 1